<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>
    <div class="statistic-content flex-item">
      <!-- <template v-for="(value, key) in TYequipment" > -->
      <div class="TYequipment-item bg1 pointer" @click="getElderDetil('摄像头')">
        <p class="TYequipment-item-name">摄像头</p>
        <p class="TYequipment-item-value">{{ TYequipment.CameraCount }}</p>
      </div>
      <div class="TYequipment-item bg2 pointer" @click="getElderDetil('雷达')">
        <p class="TYequipment-item-name">雷达</p>
        <p class="TYequipment-item-value">{{ TYequipment.LeiDaCount }}</p>
      </div>
      <div class="TYequipment-item bg3 pointer" @click="getElderDetil('红外')">
        <p class="TYequipment-item-name">红外</p>
        <p class="TYequipment-item-value">{{ TYequipment.HongWaiCount }}</p>
      </div>
      <div class="TYequipment-item bg4 pointer" @click="getElderDetil('手表')">
        <p class="TYequipment-item-name">手表</p>
        <p class="TYequipment-item-value">{{ TYequipment.WatchCount }}</p>
      </div>
      <!-- </template> -->
      <!-- <ElderDetail></ElderDetail> -->
    </div>
  </div>
</template>
  
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TYEquipmentDataStatistics',
  computed: {
    ...mapGetters(['cid']),
  },
  components: {},
  props: {
    type: {
      type: String,
      default: 'pie',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '设备数据统计',
    },
  },
  watch: {},
  data() {
    return {
      // equipment: this.$configer.equipment
      TYequipment: {}
    }
  },
  created() {
    this.getBSDeviceDatalist(this.cid)
  },
  beforeDestroy() { },
  methods: {
    getElderDetil(params) {
      this.keyWord = params
      PubSub.publish('equment', {
        keyWord: params,
        visible: true
      })
    },
    getBSDeviceDatalist(id) {
      this.$api.getYNElderDeviceDataList(id).then((result) => {
        console.log("---------->设备数据统计");
        // console.log(result);
        this.TYequipment = result
      }).catch((err) => {
        console.log(err);
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.TYequipment-item {
  width: 220px;
  height: 10.185vh;
  padding: 30px 20px;
  padding-left: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  .TYequipment-item-name {
    font-size: 14px;
    margin-bottom: 5px;
  }

  .TYequipment-item-value {
    background: -webkit-linear-gradient(#cfa998, #b84d28);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 25px;
    font-weight: bold;
    font-family: "pmzd";
  }
}

.bg1 {
  background: url(../assets/images/equment/video.png) no-repeat center/210px auto;
}

.bg2 {
  background: url(../assets/images/equment/radar.png) no-repeat center/210px auto;
}

.bg3 {
  background: url(../assets/images/equment/infrared.png) no-repeat center/210px auto;
}

.bg4 {
  background: url(../assets/images/equment/watch.png) no-repeat center/210px auto;
}</style>
  